import {
  getExternalBroker,
  editExternalBroker,
  createBrokerExternal,
  deleteBrex
} from "@/api/external-broker-api.js";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    brexList: [] // lista de brokers externos
  },
  getters: {
    // Cuenta las opportunidades registradas y no registradas
    countOpportunitiesGlobal(state) {
      let count = { register: 0, registered: 0 };
      state.brexList.forEach(brex => {
        const rawOpportunitiesArray = brex.raw_opportunities_array || [];
        count.register += rawOpportunitiesArray.filter(
          opp => !opp.registered
        ).length;
        count.registered += rawOpportunitiesArray.filter(
          opp => opp.registered
        ).length;
      });
      return count;
    }
  },
  mutations: {
    setBrexList(state, data) {
      state.brexList = data;
    },
    setBrex(state, data) {
      const index = state.brexList.findIndex(brex => brex._id == data._id);
      Vue.set(state.brexList, index, data);
    },
    addBrex(state, data) {
      state.brexList.push(data);
    },
    removeBrex(state, brexId) {
      state.brexList = state.brexList.filter(brex => brex._id != brexId);
    }
  },
  actions: {
    async fetchBrexList({ commit }, options = {}) {
      const brexs = await getExternalBroker(options);
      commit("setBrexList", brexs);
    },
    async updateBrex({ commit }, brex) {
      const edited = await editExternalBroker(brex);
      commit("setBrex", edited.data);
      return true;
    },
    async createBrex({ commit }, data) {
      try {
        const newBrex = await createBrokerExternal(data);
        commit("addBrex", newBrex);
        return newBrex;
      } catch (error) {
        return false;
      }
    },
    async createBrexExternalPresentation({ commit }, data) {
      try {
        const newBrex = await createBrokerExternal(data);
        commit("addBrex", newBrex);
        return newBrex;
      } catch (error) {
        return false;
      }
    },
    async deleteBrex({ commit }, brexId) {
      await deleteBrex(brexId);
      commit("removeBrex", brexId);
      return;
    }
  }
};
